<div class="another-look-container">
  <h5 class="header">Want another look?</h5>
  <app-offer-container
    [replacementOffers]="replacementOffers"
    [rrpFlag]="rrpFlag"
    [comparisonsSelected]="comparisons$ | async"
    (cardClicked)="onCardClick($event)"
    (comparisonClicked)="onComparisonClick($event)"
    (showMoreClicked)="onShowMoreClick($event)"
    [showMoreSize]="3"
    [dynamicCTA]="false"
  >
  </app-offer-container>
</div>
